import * as Sentry from '@sentry/vue'

export function sentryCustomMessage(errorMessage) {
  return Sentry.captureMessage(errorMessage, 'error')
}
